import React from "react";
import { Dialog } from 'primereact/dialog';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { TabView, TabPanel } from 'primereact/tabview';
import HelpIcon from '@mui/icons-material/Help';

export const OccupationStats = ({ 
  totalStockages,
  stockagesOccupes,
  stockagesLibres,
  totalStockagesRDC,
  stockagesOccupesRDC,
  stockagesLibresRDC,
  infosLibresRDC,
  infosOccupesRDC,
  totalStockagesEtg,
  stockagesOccupesEtg,
  stockagesLibresEtg,
  infosLibresEtg,
  infosOccupesEtg,
  totalStockagesCont,
  stockagesOccupesCont,
  stockagesLibresCont,
  infosLibresCont,
  infosOccupesCont
}) => {
  const [visibleRDC, setVisibleRDC] = React.useState(false);
  const [visibleEtg, setVisibleEtg] = React.useState(false);
  const [visibleCont, setVisibleCont] = React.useState(false);

  // Calcul des pourcentages
  const pourcentageTotal = totalStockages > 0 ? Math.round((stockagesOccupes / totalStockages) * 100) : 0;
  const pourcentageRDC = totalStockagesRDC > 0 ? Math.round((stockagesOccupesRDC / totalStockagesRDC) * 100) : 0;
  const pourcentageEtg = totalStockagesEtg > 0 ? Math.round((stockagesOccupesEtg / totalStockagesEtg) * 100) : 0;
  const pourcentageCont = totalStockagesCont > 0 ? Math.round((stockagesOccupesCont / totalStockagesCont) * 100) : 0;

  return (
    <div style={{ padding: "10px 0" }}>
      {/* Dialog RDC */}
      <Dialog
        header="Rez de chaussée"
        visible={visibleRDC}
        style={{ width: "70vw" }}
        onHide={() => setVisibleRDC(false)}
      >
        <TabView>
          <TabPanel header="Libres">
            <DataTable
              value={infosLibresRDC}
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25, 50]}
              size="small"
              paginatorRight={
                <span style={{ margin: "10px", fontWeight: "bold" }}>
                  Résultats : {infosLibresRDC.length}
                </span>
              }
              paginatorTemplate={
                "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
              }
            >
              <Column header="N°" field="idStockage" />
              <Column header=" Volume (m³)" field="vol" />
            </DataTable>
          </TabPanel>
          <TabPanel header="Occupés">
            <DataTable
              value={infosOccupesRDC}
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25, 50]}
              size="small"
              paginatorRight={
                <span style={{ margin: "10px", fontWeight: "bold" }}>
                  Résultats : {infosOccupesRDC.length}
                </span>
              }
              paginatorTemplate={
                "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
              }
            >
              <Column header="N°" field="idStockage" />
              <Column header=" Volume (m³)" field="vol" />
              <Column header="Client" field="nom" />
            </DataTable>
          </TabPanel>
        </TabView>
      </Dialog>

      {/* Dialog ETAGE */}
      <Dialog
        header="Etage"
        visible={visibleEtg}
        style={{ width: "70vw" }}
        onHide={() => setVisibleEtg(false)}
      >
        <TabView>
          <TabPanel header="Libres">
            <DataTable
              value={infosLibresEtg}
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25, 50]}
              size="small"
              paginatorRight={
                <span style={{ margin: "10px", fontWeight: "bold" }}>
                  Résultats : {infosLibresEtg.length}
                </span>
              }
              paginatorTemplate={
                "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
              }
            >
              <Column header="N°" field="idStockage" />
              <Column header=" Volume (m³)" field="vol" />
            </DataTable>
          </TabPanel>
          <TabPanel header="Occupés">
            <DataTable
              value={infosOccupesEtg}
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25, 50]}
              size="small"
              paginatorRight={
                <span style={{ margin: "10px", fontWeight: "bold" }}>
                  Résultats : {infosOccupesEtg.length}
                </span>
              }
              paginatorTemplate={
                "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
              }
            >
              <Column header="N°" field="idStockage" />
              <Column header=" Volume (m³)" field="vol" />
              <Column header="Client" field="nom" />
            </DataTable>
          </TabPanel>
        </TabView>
      </Dialog>

      {/* Dialog CONTENEURS */}
      <Dialog
        header="Conteneurs"
        visible={visibleCont}
        style={{ width: "70vw" }}
        onHide={() => setVisibleCont(false)}
      >
        <TabView>
          <TabPanel header="Libres">
            <DataTable
              value={infosLibresCont}
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25, 50]}
              size="small"
              paginatorRight={
                <span style={{ margin: "10px", fontWeight: "bold" }}>
                  Résultats : {infosLibresCont.length}
                </span>
              }
              paginatorTemplate={
                "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
              }
            >
              <Column header="N°" field="idStockage" />
              <Column header=" Volume (m³)" field="vol" />
            </DataTable>
          </TabPanel>
          <TabPanel header="Occupés">
            <DataTable
              value={infosOccupesCont}
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25, 50]}
              size="small"
              paginatorRight={
                <span style={{ margin: "10px", fontWeight: "bold" }}>
                  Résultats : {infosOccupesCont.length}
                </span>
              }
              paginatorTemplate={
                "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
              }
            >
              <Column header="N°" field="idStockage" />
              <Column header=" Volume (m³)" field="vol" />
              <Column header="Client" field="nom" />
            </DataTable>
          </TabPanel>
        </TabView>
      </Dialog>

      {/* En-tête avec le pourcentage total */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "8px",
        }}
      >
        <span style={{ fontSize: "24px", fontWeight: "700", color: "#1a1a1a" }}>
          {pourcentageTotal}%
        </span>
        <span style={{ fontSize: "14px", color: "#6b7280" }}>
          {stockagesOccupes} / {totalStockages}
        </span>
      </div>

      {/* Barre de progression principale */}
      <div
        style={{
          width: "100%",
          height: "24px",
          backgroundColor: "#e5e7eb",
          borderRadius: "12px",
          overflow: "hidden",
          position: "relative",
          marginBottom: "16px",
        }}
      >
        <div
          style={{
            width: `${pourcentageTotal}%`,
            height: "100%",
            backgroundColor: "#a0c959",
            borderRadius: "12px",
            transition: "width 0.6s ease",
          }}
        />
        <span
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            fontSize: "12px",
            fontWeight: "600",
            color: pourcentageTotal > 50 ? "white" : "#374151",
          }}
        >
          {pourcentageTotal}%
        </span>
      </div>

      {/* Détails par type */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "12px",
          marginTop: "8px",
        }}
      >
        {/* RDC */}
        <div
          style={{
            background: "#f8fafc",
            borderRadius: "8px",
            padding: "10px 12px",
            border: "1px solid #e2e8f0",
            cursor: "pointer",
          }}
          onClick={() => setVisibleRDC(true)}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span style={{ fontSize: "13px", fontWeight: "500", color: "#334155" }}>
              RDC
            </span>
            <span style={{ fontSize: "16px", fontWeight: "700", color: "#0f172a" }}>
              {stockagesOccupesRDC || 0}
            </span>
          </div>
          <div
            style={{
              width: "100%",
              height: "4px",
              backgroundColor: "#e5e7eb",
              borderRadius: "2px",
              marginTop: "6px",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: `${pourcentageRDC}%`,
                height: "100%",
                backgroundColor: "#a0c959",
                borderRadius: "2px",
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "4px",
              fontSize: "11px",
              color: "#94a3b8",
            }}
          >
            <span>Libre: {stockagesLibresRDC || 0}</span>
            <span>Total: {totalStockagesRDC || 0}</span>
          </div>
        </div>

        {/* ETAGE */}
        <div
          style={{
            background: "#f8fafc",
            borderRadius: "8px",
            padding: "10px 12px",
            border: "1px solid #e2e8f0",
            cursor: "pointer",
          }}
          onClick={() => setVisibleEtg(true)}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span style={{ fontSize: "13px", fontWeight: "500", color: "#334155" }}>
              Étage
            </span>
            <span style={{ fontSize: "16px", fontWeight: "700", color: "#0f172a" }}>
              {stockagesOccupesEtg || 0}
            </span>
          </div>
          <div
            style={{
              width: "100%",
              height: "4px",
              backgroundColor: "#e5e7eb",
              borderRadius: "2px",
              marginTop: "6px",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: `${pourcentageEtg}%`,
                height: "100%",
                backgroundColor: "#a0c959",
                borderRadius: "2px",
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "4px",
              fontSize: "11px",
              color: "#94a3b8",
            }}
          >
            <span>Libre: {stockagesLibresEtg || 0}</span>
            <span>Total: {totalStockagesEtg || 0}</span>
          </div>
        </div>

        {/* CONTENEURS */}
        <div
          style={{
            background: "#f8fafc",
            borderRadius: "8px",
            padding: "10px 12px",
            border: "1px solid #e2e8f0",
            cursor: "pointer",
          }}
          onClick={() => setVisibleCont(true)}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span style={{ fontSize: "13px", fontWeight: "500", color: "#334155" }}>
              Conteneurs
            </span>
            <span style={{ fontSize: "16px", fontWeight: "700", color: "#0f172a" }}>
              {stockagesOccupesCont || 0}
            </span>
          </div>
          <div
            style={{
              width: "100%",
              height: "4px",
              backgroundColor: "#e5e7eb",
              borderRadius: "2px",
              marginTop: "6px",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: `${pourcentageCont}%`,
                height: "100%",
                backgroundColor: "#a0c959",
                borderRadius: "2px",
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "4px",
              fontSize: "11px",
              color: "#94a3b8",
            }}
          >
            <span>Libre: {stockagesLibresCont || 0}</span>
            <span>Total: {totalStockagesCont || 0}</span>
          </div>
        </div>
      </div>
    </div>
  );
};